import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.scss';
import DanmapApp from './DanmapApp';
import DADPDashboardInstance from "../../vetstat_app/components/dashboard/DADPDashboardInstance";
import DashboardInstance from "../../vetstat_app/components/dashboard/DashboardInstance";
import DatasetBuilderApp from "../../vetstat_app/components/DatasetBuilderApp";
import ESCApp from "../../esc_app/ESCApp";



// *** NOTICE!!! ON danmap.org/dashboard THE DASHBOARDS ARE FLIPPED, THEREFORE THE ROUTING HERE IS SWITCHED
function App() {
    const basename = process.env.REACT_APP_API_PREFIX ?? (process.env.NODE_ENV === 'development' ? '' : '/danmap');

    return (
        <BrowserRouter basename={basename}>
            <div className="App">
                <Routes>
                    <Route path="/esc" element={<DanmapApp />} /> 
                    <Route path="/" element={<ESCApp />} />
                    <Route path="/AMU" element={
                        <>
                            <DADPDashboardInstance />
                            <DashboardInstance instanceId="primary" />
                        </>
                    } />
                    <Route path="/AMU/datasetbuilder" element={<DatasetBuilderApp />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </div>
        </BrowserRouter>
    ); 
}

export default App;